import React from "react";
import styled from "styled-components";

const ListTile = ({ leading, title, subtitle, actions, desc }) => {
  return (
    <ListTileBox>
      <LeadingBox>{leading}</LeadingBox>
      <TitleBox>
        {title}
        {subtitle}
        {desc}
      </TitleBox>
      <ActionBox>{actions}</ActionBox>
    </ListTileBox>
  );
};

export default ListTile;

export const ListTileBox = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 0px 10px 0px;
  padding: 10px 10px 10px 10px;
`;

export const LeadingBox = styled.div``;

export const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 13px;
  margin-right: 10px;
  width: 100%;
`;

export const ActionBox = styled.div`
  display: flex;
  flex-direction: row;
`;
